import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
import { useThirdPartyGates } from '../hooks/useThirdPartyGates';
import { UsesCallingWindowIsFalseEvents } from './UsesCallingWindowIsFalseEvents';
import { UsesCallingWindowIsTrueEvents } from './UsesCallingWindowIsTrueEvents';
import { UsesOpenedWindowExists } from './UsesOpenedWindowExists';
import { useOwnerId } from '../hooks/useOwnerId';
import { useUserInfo } from 'calling-ui-library/user-info/context/UserInfoContext';
import UsesHostAppEvents from './UsesHostAppEvents';
import { useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThirdPartyEventHandlers = () => {
  const {
    userId
  } = useUserInfo();
  const {
    ownerId
  } = useOwnerId({
    userId
  });
  const {
    isUngatedForClickToCallMigration
  } = useThirdPartyGates();
  const {
    selectedCallProviderData,
    isRemoteEnabled
  } = useSelectedProviderContext();
  const usesCallingWindow = !!selectedCallProviderData.usesCallingWindow;
  const hostAppEventHandlers = useMemo(() => {
    if (isUngatedForClickToCallMigration) {
      return /*#__PURE__*/_jsx(UsesHostAppEvents, {});
    }
    return null;
  }, [isUngatedForClickToCallMigration]);
  const connectionEventHandlers = useMemo(() => {
    if (ownerId === null || !selectedCallProviderData.supportsInboundCalling) {
      return null;
    }

    // remote only
    if (usesCallingWindow === false) {
      return /*#__PURE__*/_jsx(UsesCallingWindowIsFalseEvents, {
        ownerId: ownerId
      });
    }

    // remote + calling window
    if (isRemoteEnabled) {
      return /*#__PURE__*/_jsx(UsesCallingWindowIsTrueEvents, {
        ownerId: ownerId
      });
    }

    // calling window only
    return /*#__PURE__*/_jsx(UsesOpenedWindowExists, {
      ownerId: ownerId
    });
  }, [isRemoteEnabled, usesCallingWindow, ownerId, selectedCallProviderData.supportsInboundCalling]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [hostAppEventHandlers, connectionEventHandlers]
  });
};
export default ThirdPartyEventHandlers;